import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * ReferralTracker — captures ?ref=CODE from URL, stores in localStorage + cookie,
 * and records a click in referral_clicks (deduplicated per visitor per day).
 * Mount once in Routes.jsx or App.jsx.
 */
export default function ReferralTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refCode = params?.get('ref');
    if (!refCode) return;

    // Store in localStorage (use both keys for compatibility)
    localStorage.setItem('adt_referral_code', refCode);
    localStorage.setItem('referral_code', refCode);

    // Store in cookie valid 30 days
    const expires = new Date();
    expires?.setDate(expires?.getDate() + 30);
    document.cookie = `referral_code=${encodeURIComponent(refCode)}; expires=${expires?.toUTCString()}; path=/; SameSite=Lax`;

    // Record click in Supabase (fire-and-forget, deduplicated server-side)
    const recordClick = async () => {
      try {
        await supabase?.rpc('record_referral_click', {
          p_referral_code: refCode,
          p_ip_address: null, // IP not available client-side
          p_user_agent: navigator?.userAgent || null,
          p_landing_page: window?.location?.href || null
        });
      } catch (err) {
        // Non-blocking — silently ignore errors
        console.warn('[ReferralTracker] Could not record click:', err?.message);
      }
    };

    recordClick();
  }, [location?.search]);

  return null;
}
